import {useState } from 'react';
import { Container, Row, Col, Form, Button,Alert } from 'react-bootstrap';
import seoMetaData from '../../Include/Seo/seoMetaData';
import { Helmet } from 'react-helmet';
import men from "../../../assets/images/men.svg";
import Navbar from '../../Include/Navbar/Navbar';
import Footer from '../../Include/Footer/Footer';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    message: '',
    resume: null,
    agree: false,
  });

  const [validated, setValidated] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === 'file') {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    // Phone validation
    const phoneRegex = /^[0-9]{10}$/;
    const isPhoneValid = phoneRegex.test(formData.phone);

    if (!form.checkValidity() || !isPhoneValid || !formData.resume || !formData.agree) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    setLoading(true);
    setValidated(true);

    try {
      const data = new FormData();
      data.append('firstName', formData.firstName);
      data.append('lastName', formData.lastName);
      data.append('email', formData.email);
      data.append('phone', formData.phone);
      data.append('position', formData.position);
      data.append('message', formData.message);
      data.append('resume', formData.resume);
      data.append('agree', formData.agree);

      // Replace this with your actual API endpoint
      const response = await fetch('https://cp.cloudkodeform.com/api/job-application/apply', {
        method: 'POST',
        body: data,
      });
      const responseData = await response.json();
      if (response.ok && responseData.status) {
        setSuccessMessage(responseData.message +" with application number  "+responseData.data);
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          position: '',
          message: '',
          resume: null,
          agree: false,
        });
        setValidated(false);
      } else {
        setSuccessMessage(responseData.message);
      }
    } catch (error) {
      console.error('Submit error:', error);
      setSuccessMessage('Something went wrong. Please try again later.');
    }

    setLoading(false);
  };

 const { title, description } = seoMetaData.career;
  return (
    <>
     <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href="https://www.cloudkodeform.com/cookie-policy" />
      </Helmet>
    
      <Navbar />
      <section className="contact-section">
        <Container>
          <Row className="align-items-center">
            {/* Form Side */}
            <Col lg={6} md={12} className="mb-4">
              <h2 className="left-about-content-home">
                Apply for Your Next Opportunity <span className="orange-dot">.</span>
              </h2>
              <p className="right-about-content-home">
                Ready to take the next step in your career? Fill out the form and join our growing team at CloudKodeForm Technologies.
              </p>

              {successMessage && (
                <Alert variant="success" onClose={() => setSuccessMessage('')} dismissible>
                  {successMessage}
                </Alert>
              )}

              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>First Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        First name is required.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Last Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Last name is required.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Valid email is required.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number *</Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        pattern="[0-9]{10}"
                        minLength={10}
                        maxLength={10}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter a valid 10-digit phone number.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
  <Form.Label>Position Applying For *</Form.Label>
  <Form.Select
    name="position"
    value={formData.position}
    onChange={handleChange}
    required
  >
    <option value="">-- Select Position --</option>
    <option value="Frontend Developer">Frontend Developer</option>
    <option value="Backend Developer">Backend Developer</option>
    <option value="Full Stack Developer">Full Stack Developer</option>
    <option value="UI/UX Designer">UI/UX Designer</option>
    <option value="Database Manager">Database Manager</option>
    <option value="Project Manager">Project Manager</option>
    <option value="QA Engineer">QA Engineer</option>
    <option value="DevOps Engineer">DevOps Engineer</option>
    <option value="Business Analyst">Business Analyst</option>
    <option value="Product Manager">Product Manager</option>
    <option value="Mobile App Developer">Mobile App Developer</option>
    <option value="Cloud Architect">Cloud Architect</option>
    <option value="Data Scientist">Data Scientist</option>
    <option value="Machine Learning Engineer">Machine Learning Engineer</option>
    <option value="Technical Support Engineer">Technical Support Engineer</option>
    <option value="Cybersecurity Analyst">Cybersecurity Analyst</option>
    <option value="Others">Others</option>
  </Form.Select>
  <Form.Control.Feedback type="invalid">
    Position is required.
  </Form.Control.Feedback>
</Form.Group>


               <Form.Group className="mb-3">
  <Form.Label>Upload Resume *</Form.Label>
  <Form.Control
    type="file"
    name="resume"
    onChange={handleChange}
    required
  />
  <Form.Control.Feedback type="invalid">
    Please upload a valid resume (PDF or Word only).
  </Form.Control.Feedback>
</Form.Group>


                <Form.Group className="mb-3">
                  <Form.Label>Cover Letter / Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="agree"
                    checked={formData.agree}
                    onChange={handleChange}
                    label={
                      <>
                        I agree to CloudKodeForm’s recruitment privacy terms. <br />
                        <small>You can read our <a href="/recruitment-privacy-policy" target="_blank" rel="noopener noreferrer">Recruitment Privacy Policy</a>.</small>
                      </>
                    }
                    required
                    feedback="You must agree before submitting."
                    feedbackType="invalid"
                  />
                </Form.Group>

                <Button className="orange-button" type="submit" disabled={loading}>
                  {loading ? 'Submitting...' : 'Submit Application'}
                </Button>
              </Form>
            </Col>

            {/* Image Side */}
            <Col lg={6} md={12} className="text-center">
              <img
                src={men}
                alt="Apply for Job"
                className="img-fluid contact-img"
              />
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  );
}
